import React, { useEffect, useState } from 'react';

const areaLabel = { matematica: 'Matemática', fisica: 'Física', quimica: 'Química', astronomia: 'Astronomia', midia: 'Mídia' };

function PersonCard({ person }) {
    return (
        <div className="membro">
            {person.photoUrl ? (
                <img src={person.photoUrl} className="imagem-circular" alt={person.name} />
            ) : (
                <div className="imagem-circular" style={{ display: 'grid', placeItems: 'center', background: '#fff', color: '#0c2e4f', fontWeight: 700, fontSize: 20 }}>
                    {person.name.split(' ').slice(0, 2).join(' ')}
                </div>
            )}
            <center>
                <h3 className="fontezao3cor">{person.name}</h3>
                {person.role && <h5 className="textozao">{person.role}</h5>}
                {person.area && <h5 className="textozao">{person.area}</h5>}
            </center>
        </div>
    );
}

function PersonGrid({ people }) {
    if (people.length === 0) return null;
    return (
        <div className="equipe-container">
            {people.map(person => <PersonCard key={person.id} person={person} />)}
        </div>
    );
}

const QuemSomos = () => {
    const [people, setPeople] = useState([]);

    useEffect(() => {
        let active = true;
        fetch('/api/people')
            .then(response => response.ok ? response.json() : Promise.reject(response))
            .then(data => {
                if (active) setPeople(Array.isArray(data.items) ? data.items : []);
            })
            .catch(() => {
                if (active) setPeople([]);
            });
        return () => { active = false; };
    }, []);

    const active = people.filter(p => p.status !== 'ex-colaborador');
    const exColaboradores = people.filter(p => p.status === 'ex-colaborador');

    const diretoria = active.filter(p => p.category === 'diretoria');
    const coordenadores = active.filter(p => p.category === 'coordenador');
    const membros = active.filter(p => p.category === 'membro');

    const boardYears = [...new Set(diretoria.map(p => p.year).filter(Boolean))].sort();
    const departments = ['Matemática', 'Física', 'Química', 'Astronomia', 'Mídia'];

    return (
        <div className="fundo">
            <h1 className="fontezaocor">NOSSA HISTÓRIA E OBJETIVOS</h1>
            <br/>
            <div className="text-container">
                <h4 className="fontezao2cor">"Toc, toc! Quem é?"</h4>
            </div>
            <div className="text-container">
                <h4 className="cor">
                    São as oportunidades batendo à sua porta, trazendo a chance de cruzar o mundo para viver uma experiência transformadora em uma olimpíada internacional. O quão egoístas seríamos se, conhecendo tantas possibilidades, simplesmente deixássemos de compartilhá-las com o restante da sociedade? Reclamar da corrupção e das injustiças não basta; precisamos ser os agentes da mudança que queremos ver.
                </h4>
                <br/>
                <h4 className="cor">
                É por isso que nasceu o Olympic Birds: um projeto educacional gratuito, movido pela determinação de transformar o Brasil. Nosso propósito é democratizar o acesso a oportunidades acadêmicas, como olimpíadas científicas e vestibulares, enquanto oferecemos conteúdos de qualidade para inspirar e capacitar aqueles que desejam atingir seu máximo potencial. Porque juntos, podemos abrir nossas asas e voar rumo a um futuro melhor!
                </h4>
            </div>
            <br/>

            {diretoria.length > 0 && <>
                <h1 className="fontezaocor">DIRETORIA</h1>
                {boardYears.map(year => {
                    const members = diretoria.filter(p => p.year === year);
                    if (members.length === 0) return null;
                    return <React.Fragment key={year}>
                        <h3 className="fontezaocor">Diretoria {year}</h3>
                        <PersonGrid people={members} />
                        <br/>
                    </React.Fragment>;
                })}
                {diretoria.filter(p => !p.year).length > 0 && <>
                    <PersonGrid people={diretoria.filter(p => !p.year)} />
                    <br/>
                </>}
            </>}

            {coordenadores.length > 0 && <>
                <h1 className="fontezaocor">COORDENADORES</h1>
                {departments.map(dept => {
                    const members = coordenadores.filter(p => p.area === dept);
                    if (members.length === 0) return null;
                    return <React.Fragment key={dept}>
                        <h3 className="fontezaocor">{dept}</h3>
                        <PersonGrid people={members} />
                        <br/>
                    </React.Fragment>;
                })}
                {coordenadores.filter(p => !departments.includes(p.area)).length > 0 && <>
                    <PersonGrid people={coordenadores.filter(p => !departments.includes(p.area))} />
                    <br/>
                </>}
            </>}

            {membros.length > 0 && <>
                <h1 className="fontezaocor">MEMBROS</h1>
                {departments.map(dept => {
                    const members = membros.filter(p => p.area === dept);
                    if (members.length === 0) return null;
                    return <React.Fragment key={dept}>
                        <h3 className="fontezaocor">Departamento de {dept}</h3>
                        <PersonGrid people={members} />
                        <br/>
                    </React.Fragment>;
                })}
                {membros.filter(p => !departments.includes(p.area)).length > 0 && <>
                    <PersonGrid people={membros.filter(p => !departments.includes(p.area))} />
                    <br/>
                </>}
            </>}

            {exColaboradores.length > 0 && <>
                <h1 className="fontezaocor">EX-COLABORADORES</h1>
                <PersonGrid people={exColaboradores} />
                <br/>
            </>}
        </div>
    );
};

export default QuemSomos;
